// Third-party libraries
import React, { useContext, useState } from "react";
import {
  Select,
  Stack,
  Typography,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";

// Local modules
import { ProductsContext } from "../../../../utils/stateHandlers/contexts";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function FingerSize(props) {
  const { productState, productDispatch } = useContext(ProductsContext);
  const { validationErrors, priceLoaded } = productState;
  const [localFingerSize, setLocalFingerSize] = useState(null);
  const field = props.field;

  function selectFingerSize(finger_size) {
    if (finger_size === "None") {
      productDispatch({
        type: "setValidationErrors",
        payload: [...validationErrors, "finger_size"],
      });
    } else {
      const remove = validationErrors.filter(function (error) {
        return error !== "finger_size";
      });
      productDispatch({ type: "setValidationErrors", payload: remove });
    }
    productDispatch({ type: "setClear", payload: false });
    setLocalFingerSize(finger_size);
    productDispatch({
      type: "updateFields",
      field: "finger_size",
      payload: finger_size,
    });
  }

  // useEffect(() => {
  //   if (clear) {
  //     productDispatch({ type: "setClear", payload: false });
  //     productDispatch({
  //       type: "setValidationErrors",
  //       payload: [...validationErrors, "finger_size"],
  //     });
  //     setLocalFingerSize("None");
  //     productDispatch({
  //       type: "updateFields",
  //       field: "finger_size",
  //       payload: "None",
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clear]);

  return (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <FormControl error={localFingerSize === "None" ? true : false}>
        <Select
          value={localFingerSize === null ? field.default : localFingerSize}
          size="small"
          sx={{ width: "100%" }}
          disabled={!priceLoaded || (field.values && field.values.length === 1)}
          onChange={(e) => {
            selectFingerSize(e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #939598",
                borderRadius: "0",
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              },
            },
          }}
        >
          <MenuItem value="None">
            <em>Select...</em>
          </MenuItem>
          {field.values &&
            field.values.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>
          {localFingerSize === "None" ? "Please Make A Selection" : ""}
        </FormHelperText>
      </FormControl>
    </Stack>
  );
}
